import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LinkOutlined from '@mui/icons-material/LinkOutlined';
import { tokens } from 'app/components/MatxTheme/themeColors';
import { useCopyLink } from '../permalinks';

// Icon button that copies the absolute permalink for `path` to the
// clipboard. Sized to sit beside the other 18px header icons in the
// observation and media dialogs.
const CopyLinkButton = ({ path, label = 'Copy link' }) => {
  const copyLink = useCopyLink();
  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        aria-label={label}
        onClick={(e) => {
          e.stopPropagation();
          copyLink(path);
        }}
      >
        <LinkOutlined sx={{ fontSize: 18, color: tokens.grey[800] }} />
      </IconButton>
    </Tooltip>
  );
};

export default CopyLinkButton;
